import { render, staticRenderFns } from "./mainFooter.vue?vue&type=template&id=804e98ce&scoped=true"
import script from "./mainFooter.vue?vue&type=script&lang=js"
export * from "./mainFooter.vue?vue&type=script&lang=js"
import style0 from "./mainFooter.vue?vue&type=style&index=0&id=804e98ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804e98ce",
  null
  
)

export default component.exports